import { footerColumns, siteMeta } from "@/mocks/home";

export default function SiteFooter() {
  return (
    <footer className="bg-primary-950 text-background-100">
      <div className="mx-auto w-full max-w-[1240px] px-4 py-12 md:px-6 md:py-14">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-[1.4fr_1fr_1fr_1fr] md:gap-10">
          <div>
            <div className="flex items-center gap-2.5">
              <span className="font-sans flex h-8 w-8 items-center justify-center rounded-md bg-background-50 text-sm font-bold text-primary-800">
                88
              </span>
              <span className="font-heading text-xl font-bold tracking-wide text-background-50">
                看料
              </span>
            </div>
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-background-200/80">
              {siteMeta.slogan}
            </p>
            <p className="mt-4 text-xs text-background-300/70">
              {siteMeta.issue} · {siteMeta.edition} · 更新于 {siteMeta.updatedAt}
            </p>
          </div>

          {footerColumns.map((column) => (
            <div key={column.title}>
              <h3 className="font-heading text-sm font-semibold text-background-50">{column.title}</h3>
              <ul className="mt-4 space-y-2.5">
                {column.links.map((link) => (
                  <li key={link}>
                    <a
                      href="#top-story"
                      className="text-sm text-background-200/80 transition-colors hover:text-background-50"
                    >
                      {link}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-background-50/15 pt-6 text-xs text-background-300/70 sm:flex-row sm:items-center sm:justify-between">
          <p>© {new Date().getFullYear()} 88看料 · 单页内参版，内容仅作展示演示</p>
          <p className="flex flex-wrap items-center gap-x-5 gap-y-2">
            <span>来源说明</span>
            <span>隐私声明</span>
            <span>更新节奏</span>
          </p>
        </div>
      </div>
    </footer>
  );
}